import TextField from '@mui/material/TextField';

interface NodeTextFieldProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
}

const NodeTextField = ({label, value, onChange, placeholder, disabled}: NodeTextFieldProps) => (
    <TextField
        fullWidth
        size={'small'}
        margin={'none'}
        label={label}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={event => onChange(event.target.value)}
    />
);

export default NodeTextField;
